import { SearchPage } from './SearchPage'
import { withSearchPage } from './withSearchPage'

const ConnectedSearchPage = withSearchPage(SearchPage)

export { ConnectedSearchPage as SearchPage }
